export const props = { viewBox: "0 0 24.5 24.5" };
export const innerHTML = `
<svg>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.351 3.35742C15.8488 2.49387 14.1071 2 12.25 2C10.3909 2 8.64735 2.49496 7.14402 3.3603L7.14402 21.1397C8.64735 22.005 10.3909 22.5 12.25 22.5C14.1071 22.5 15.8488 22.0061 17.351 21.1426L17.351 3.35742ZM24.5 12.25C24.5 5.48452 19.0155 2.73854e-06 12.25 2.44281e-06C5.48451 2.14708e-06 8.31193e-07 5.48451 5.35464e-07 12.25C2.39736e-07 19.0155 5.48451 24.5 12.25 24.5C19.0155 24.5 24.5 19.0155 24.5 12.25Z"/>
</svg>`;
